import axios from 'axios';
import { getUserInfo, setUserInfo } from '@/utils/auth';
import { filterParams } from '@/utils/index';
import { startLoading, closeLoading } from './globalLoading';
import Catcher from './errCatcher';

window.cancelTokenList = [];

const service = axios.create({
  // timeout: 15000
});

service.interceptors.request.use((config) => {
  const { token } = getUserInfo();
  if (token) config.headers.Authorization = token;
  filterParams(config.data || config.params || {});
  startLoading(config);
  const source = axios.CancelToken.source();
  window.cancelTokenList.push(source);
  config.cancelToken = source.token;
  return config;
}, (error) => {
  Promise.reject(error);
});

service.interceptors.response.use(
  (response) => {
    closeLoading();
    // 处理全局CancelToken List
    window.cancelTokenList = window.cancelTokenList
      .filter(x => x.token !== response.config.cancelToken);
    if (response.headers.authorization) setUserInfo(response.headers.authorization);
    const res = response && response.data;
    if (res.status !== 1) Catcher(response);
    return res;
  },
  (error) => {
    closeLoading();
    Catcher(error.response, true);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/api/axios.js